import Globals from './globals';

class Error {

	default = (err: any) => {
		if (err.response && err.response.status === 422) {
			const data = err.response.data
			const error = (data && (data?.message || data?.error)) || err.response.statusText
			Globals.showError(error);
			return;
		}
		else {
			console.log(err);
			Globals.showError();
		}
	}
}

export default new Error();